<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">list</mat-icon>
        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{'main.eLearning' | translate}}
          </div>
          <div class="subtitle secondary-text">
            <span>{{'add_spaces_boards' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <div>
        <button mat-raised-button
          [routerLink]="'/pages/settings/spaces/new'"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'main.add' | translate}}</span>
        </button>
      </div>

    </div>


    <div class="content-card mat-white-bg">
      <!-- / SEARCH -->
      <div class="categories" cdkDropList (cdkDropListDropped)="dropSpaces($event)">
        @if (spaces.length) {
          @for (sp of spaces; track sp; let i = $index) {
            <div class="cat-grid" cdkDrag cdkDragPreviewClass="space-preview">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="cat-header">
                        <span>{{sp.name}}  <span class="platform">({{'platform.title' | translate}}: {{sp?.platform?.title}})</span></span>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="board-list" cdkDropList (cdkDropListDropped)="drop($event, i)">
                    @for (spb of sp.spaceBoard; track spb) {
                      <div class="cat-content" cdkDrag>
                        <div class="name">{{spb.name}}</div>
                        <div class="icons">
                          <mat-icon style="color: orange" (click)="editSpaceBoard(spb, sp.id)" class="sub-mat-icon">edit</mat-icon>
                          <mat-icon style="color: red" (click)="deleteSpaceBoard(spb.id, sp.id)" class="sub-mat-icon">clear</mat-icon>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="add-subcat" (click)="addSpaceBoard(sp.id)">{{'add_board' | translate}}</div>
                </mat-expansion-panel>
              </mat-accordion>
              <mat-icon style="color: orange" (click)="editSpace(sp.id, sp.name, sp.platformId)" class="main-mat-icon">edit</mat-icon>
              <mat-icon style="color: red" (click)="deleteSpace(sp.id)" class="main-mat-icon">clear</mat-icon>
            </div>
          }
        }
      </div>
      @if (!spaces?.length) {
        <div class="no-data-msg">
          <span class="mat-headline-6">{{'main.noData' | translate}}</span>
        </div>
      }
      <!--      <mat-paginator-->
      <!--        [pageSize]="pageSize"-->
      <!--        [pageSizeOptions]="[5, 10, 20]"-->
      <!--        [pageIndex]="pageIndex"-->
      <!--        [length]="totalCount"-->
      <!--        (page)="changePageEmitter($event)"-->
    <!--        showFirstLastButtons></mat-paginator>-->
  </div>
  <!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>
